import {
  Box,
  Divider,
  Flex,
  IconButton,
  Tab,
  TabList,
  Tabs,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { IoIosArrowRoundBack } from 'react-icons/io'
import { useHistory, useLocation } from 'react-router-dom'
import GenerateImageForm from '../../components/MediaLibrary/GenerateImage/GenerateImageForm'
import GenerateImageHistory from '../../components/MediaLibrary/GenerateImage/GenerateImageHistory'
import { useQueryState } from '../../hooks/useQueryState'
import BaseLayout from '../Base/BaseLayout'

const GenerateImagesLayout = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const [tabIndex, setTabIndex] = useQueryState<string>('generate', 'tab')

  const handleTabChange = (index: number) => {
    const queryParams = new URLSearchParams()

    if (index === 0) {
      queryParams.set('tab', 'generate')
      setTabIndex('generate')
    } else {
      queryParams.set('tab', 'history')
      setTabIndex('history')
    }
    history.replace({
      pathname: location.pathname,
      search: queryParams.toString(),
    })
  }

  return (
    <BaseLayout>
      <Box position="sticky" top="0" zIndex="docked" bg="white">
        <Flex p="11px 24px 10px 24px">
          <IconButton
            aria-label={t('back', 'Back')}
            variant="link"
            icon={<IoIosArrowRoundBack size="21px" color="#6C7686" />}
            borderRadius="4px"
            border="1px solid #E6E7EA"
            onClick={() => {
              history.goBack()
            }}
          />
          <Flex justify="center" flex="1">
            <Tabs
              variant="soft-rounded"
              colorScheme="appBlue"
              index={tabIndex === 'generate' ? 0 : 1}
              onChange={handleTabChange}
            >
              <TabList>
                <Tab>{t('generate', 'Generate')}</Tab>
                <Tab>{t('history', 'History')}</Tab>
              </TabList>
            </Tabs>
          </Flex>
        </Flex>
        <Divider color="appPaleLilac" />
      </Box>
      {tabIndex === 'generate' ? (
        <GenerateImageForm />
      ) : (
        <GenerateImageHistory />
      )}
    </BaseLayout>
  )
}

export default GenerateImagesLayout
